export enum PropertyTypeEnum {
	UserProperty = 'u',
	IProperty = 'i',
	VirtualProperty = 'v',
	Paramdiv = 'p'
}